<template>
    <div>
        <img class="photo-additional" v-lazy-load data-src="~/assets/img/loyalty-2.jpg" alt="" />
        <div class="loyaltyProgram">
            <h1 class="loyaltyProgram_title">программа лояльности 'нити'</h1>
            <div class="loyaltyProgram_about" :class="{ is_minimize: !isMinimizedDescription }">
                <div class="loyaltyProgram_about_column">
                    <p class="loyaltyProgram_about_text">
                        мы все связаны друг с другом невидимыми нитями. чем ближе мы становимся друг к другу, тем крепче
                        становится нить и тем сильнее укрепляется наша связь.
                        <template v-if="$device.isDesktop">
                            <br /><br />
                            программа лояльности 'нити' — закрепи свою связь с p.p.s. регистрируйся в программе
                            лояльности, получи виртуальную карту, оплачивай покупки, копи нити и открывай эксклюзивные
                            преимущества на каждом из уровней программы.
                        </template>
                    </p>
                </div>
                <transition name="fade" :duration="200">
                    <div class="loyaltyProgram_about_column" v-if="$device.isDesktop || !isMinimizedDescription">
                        <p class="loyaltyProgram_about_text">
                            <template v-if="$device.isMobile">
                                программа лояльности 'нити' — закрепи свою связь с p.p.s. регистрируйся в программе
                                лояльности, получи виртуальную карту, оплачивай покупки, копи нити и открывай
                                эксклюзивные преимущества на каждом из уровней программы.
                                <br /><br />
                            </template>
                            we are all connected to each other by invisible threads. the closer we get to each other,
                            the stronger the thread becomes, and the tighter our bond grows.
                            <br /><br />
                            the threads loyalty program will allow you to strengthen your connection with p.p.s. sign up
                            for the program, earn and collect points for purchases, redeem them for discounts, receive
                            gifts, exclusive offers, access to exclusive events and many more perks.
                        </p>
                    </div>
                </transition>
                <div class="loyaltyProgram_about_minimize color-accent text_11" v-if="$device.isMobile">
                    <div @click="isMinimizedDescription = !isMinimizedDescription">
                        {{ isMinimizedDescription ? "подробнее" : "свернуть" }}
                    </div>
                </div>
            </div>
            <div class="loyaltyProgram_comparison" v-if="$device.isDesktop">
                <table>
                    <thead>
                        <tr>
                            <td></td>
                            <td>
                                <svg
                                    width="128"
                                    height="128"
                                    viewBox="0 0 128 128"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="64" width="90" height="90" transform="rotate(45 64 0)" fill="#AC82F1" />
                                </svg>
                            </td>
                            <td>
                                <svg
                                    width="128"
                                    height="128"
                                    viewBox="0 0 128 128"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="64" width="90" height="90" transform="rotate(45 64 0)" fill="#EB0062" />
                                </svg>
                            </td>
                            <td>
                                <svg
                                    width="128"
                                    height="128"
                                    viewBox="0 0 128 128"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="64" width="90" height="90" transform="rotate(45 64 0)" fill="black" />
                                </svg>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>вид</td>
                            <td v-for="(item, index) in comparisonOptions" :key="'vid' + index">{{ item.name }}</td>
                        </tr>
                        <tr>
                            <td>условия получения</td>
                            <td v-for="(item, index) in comparisonOptions" :key="'cond' + index">
                                {{ item.condition }}
                            </td>
                        </tr>
                        <tr>
                            <td>нити-бонусы</td>
                            <td v-for="(item, index) in comparisonOptions" :key="'thred' + index">{{ item.bonus }}</td>
                        </tr>
                        <tr>
                            <td>оплата бонусами</td>
                            <td v-for="(item, index) in comparisonOptions" :key="'pay' + index">{{ item.payLimit }}</td>
                        </tr>
                        <tr>
                            <td>бонусы в день рождения</td>
                            <td v-for="(item, index) in comparisonOptions" :key="'bd' + index">
                                {{ item.birthdayBonus ? "да" : "нет" }}
                            </td>
                        </tr>
                        <tr>
                            <td>ранний доступ к распродажам</td>
                            <td v-for="(item, index) in comparisonOptions" :key="'early' + index">
                                {{ item.salesAccess ? "да" : "нет" }}
                            </td>
                        </tr>
                        <tr>
                            <td>закрытые мероприятия</td>
                            <td v-for="(item, index) in comparisonOptions" :key="'closed' + index">
                                {{ item.eventsAccess ? "да" : "нет" }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="loyaltyProgram_comparison" v-else>
                <swiper :options="mobileSliderOptions">
                    <swiper-slide>
                        <div class="loyaltyProgram_comparison-slide">
                            <svg
                                width="128"
                                height="128"
                                viewBox="0 0 128 128"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="64" width="90" height="90" transform="rotate(45 64 0)" fill="#AC82F1" />
                            </svg>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="loyaltyProgram_comparison-slide">
                            <svg
                                width="128"
                                height="128"
                                viewBox="0 0 128 128"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="64" width="90" height="90" transform="rotate(45 64 0)" fill="#EB0062" />
                            </svg>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="loyaltyProgram_comparison-slide">
                            <svg
                                width="128"
                                height="128"
                                viewBox="0 0 128 128"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="64" width="90" height="90" transform="rotate(45 64 0)" fill="black" />
                            </svg>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-pagination"></div>
            </div>
            <div class="loyaltyProgram_comparison-table" v-if="$device.isMobile">
                <table>
                    <tr>
                        <td>вид</td>
                        <td>{{ comparisonOptions[mobileSliderSlide].name }}</td>
                    </tr>
                    <tr>
                        <td>условия получения</td>
                        <td>{{ comparisonOptions[mobileSliderSlide].condition }}</td>
                    </tr>
                    <tr>
                        <td>нити-бонусы</td>
                        <td>{{ comparisonOptions[mobileSliderSlide].bonus }}</td>
                    </tr>
                    <tr>
                        <td>оплата бонусами</td>
                        <td>{{ comparisonOptions[mobileSliderSlide].payLimit }}</td>
                    </tr>
                    <tr>
                        <td>бонусы в день рождения</td>
                        <td>{{ comparisonOptions[mobileSliderSlide].birthdayBonus ? "да" : "нет" }}</td>
                    </tr>
                    <tr>
                        <td>ранний доступ к распродажам</td>
                        <td>{{ comparisonOptions[mobileSliderSlide].salesAccess ? "да" : "нет" }}</td>
                    </tr>
                    <tr>
                        <td>закрытые мероприятия</td>
                        <td>{{ comparisonOptions[mobileSliderSlide].eventsAccess ? "да" : "нет" }}</td>
                    </tr>
                </table>
            </div>
            <nuxt-link :to="$auth.loggedIn ? '/lk/login' : '/lk/register'" class="loyaltyProgram_button"
                >потяни</nuxt-link
            >
            <div class="loyaltyProgram_rules">
                нить — это единица расчетов в программе лояльности.<br />
                <br />
                ‘1’ рубль = ‘1’ нить<br />
                <br />
                нити начисляются на 15-й день после совершения каждой покупки.<br />
                <br />
                накопленными нитями можно оплачивать покупки в интернет-магазине или в студиях pps.<br />
                <br />
                по мере роста суммы покупок ты получаешь эксклюзивные преимущества и автоматический переход на следующий
                уровень программы лояльности:<br />
                <br />
                при достижении суммы всех покупок в размере 100 000₽, присваивается уровень ‘красная нить‘.<br />
                <br />
                при достижении суммы всех покупок в размере 200 000 ₽ ты переходишь на уровень ‘черная нить’<br />
                <br />
                после повышения уровня необходимо сохранить свой новый уровень в течение 12 месяцев.<br />
                <br />
                в случае применения промокодов или наличия акционных товаров в корзине, списание и начисление нитей
                недоступно.
            </div>
            <div class="loyaltyProgram_link">
                <!--                <nuxt-link to="/loyalty-program/rules">правила программы лояльности</nuxt-link>-->
                <a href="https://wa.me/79399006343">остались вопросы?</a>
            </div>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "@/plugins/swiper.client";

export default {
    name: "loyaltyProgram",
    components: { Swiper, SwiperSlide },
    head() {
        return {
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "keywords",
                    property: "keywords",
                    content: this.seo?.keywords ? this.seo.keywords : "",
                },
            ],
        };
    },
    data() {
        return {
            isMinimizedDescription: true,
            seo: {},
            comparisonOptions: [
                {
                    name: "фиолетовая нить",
                    condition: "анкета",
                    bonus: "Кешбэк 5% от суммы покупки",
                    payLimit: "50%",
                    birthdayBonus: true,
                    salesAccess: false,
                    eventsAccess: false,
                },
                {
                    name: "красная нить",
                    condition: "сумма",
                    bonus: "Кешбэк 10% от суммы покупки",
                    payLimit: "100%",
                    birthdayBonus: true,
                    salesAccess: true,
                    eventsAccess: false,
                },
                {
                    name: "черная нить",
                    condition: "сумма",
                    bonus: "Кешбэк 15% от суммы покупки",
                    payLimit: "100%",
                    birthdayBonus: true,
                    salesAccess: true,
                    eventsAccess: true,
                },
            ],
            mobileSliderOptions: {
                slidesPerView: 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                on: {
                    slideChange: (swiper) => {
                        this.mobileSliderSlide = swiper.activeIndex;
                    },
                },
            },
            mobileSliderSlide: 0,
        };
    },
    async asyncData({ $axios }) {
        const seo = await $axios.get("/api/seo/loyalty-program");
        return {
            seo: seo.data,
        };
    },
    computed: {
        crumbs() {
            return [{ name: this.$i18n.t("pps_club") }];
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
    },
};
</script>

<style scoped lang="less">
.photo-additional {
    width: 100%;
    max-height: 504px;
    object-fit: cover;
}
.loyaltyProgram {
    display: flex;
    position: relative;
    z-index: 1;
    flex-direction: column;
    align-items: center;
    width: 100%;
    font-weight: 400;
    letter-spacing: 0.03em;
    text-align: left;
    margin-bottom: 64px;
    @media @sm {
        margin-bottom: 40px;
    }
    &_title {
        margin-top: 60px;
        width: 100%;
        padding: 0 103px;
        font-size: 48px;
        font-weight: 400;
        line-height: 57.6px;
        letter-spacing: 0.16em;
        text-align: left;
        @media @sm {
            font-size: 28px;
            line-height: 33.6px;
            margin: 0;
            padding: 32px 0 0 16px;
        }
    }
    &_about {
        display: flex;
        gap: 63px;
        letter-spacing: 0.16em;
        padding: 80px 103px;
        justify-content: space-between;
        &_column {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 40px;
            @media @notsm {
                width: 50%;
            }
            @media @sm {
                gap: 25px;
            }
        }
        @media @sm {
            gap: 25px;
        }
        &_minimize {
            margin-top: -9px;
        }
        &_text {
            font-size: 13px;
            font-weight: 400;
            letter-spacing: 0.16em;
            line-height: 20.8px;
            @media @sm {
                font-size: 11px;
                font-weight: 400;
                text-align: left;
            }
        }
    }
    &_button {
        width: 100%;
        max-width: 400px;
        height: 50px;
        padding: 14px 130px 14px 130px;
        gap: 10px;
        background-color: #000000;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0.16em;
        text-align: center;
        @media @sm {
            width: calc(100% - 32px);
            max-width: none;
            margin-top: 31px;
            margin-bottom: 60px;
            height: 41px;
            display: flex;
            padding: 0;
            justify-content: center;
            align-items: center;
            font-size: 11px;
            line-height: 15px;
        }
    }
    &_comparison {
        margin-top: 20px;
        width: 100%;
        padding: 0 103px 80px;
        position: relative;
        overflow: hidden;
        @media @sm {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 0 50px;
        }
        &-table {
            margin-top: 30px;
            table {
                width: 100%;
                table-layout: fixed;
                font-size: 11px;
                font-weight: 400;
                line-height: 15.4px;
                letter-spacing: 0.16em;
                text-align: right;
                td {
                    padding: 12.5px 0 12.5px 16px;
                    border-bottom: 1px solid @border2;
                    &:first-child {
                        text-align: initial;
                        font-weight: 550;
                    }
                    &:last-child {
                        padding: 12.5px 16px 12.5px 0;
                    }
                }
            }
        }
        &-slide {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        table {
            width: 100%;
            table-layout: fixed;
            font-size: 11px;
            font-weight: 400;
            line-height: 15.4px;
            letter-spacing: 0.16em;
            tbody tr {
                td {
                    padding: 18px 0;
                    border-top: 1px solid @border2;
                    &:first-child {
                        padding: 20px 0;
                        font-weight: 550;
                        line-height: 11px;
                    }
                }
                &:last-child td {
                    border-bottom: 1px solid @border2;
                }
            }
            thead td {
                padding: 0 0 18px;
                border: none;
            }
        }
    }
    &_link {
        margin-top: 150px;
        color: #7b7b7b;
        font-size: 13px;
        font-weight: 400;
        letter-spacing: 0.16em;
        text-align: center;
        text-decoration: underline;
        display: flex;
        flex-direction: column;
        gap: 30px;
        @media @sm {
            gap: 20px;
            font-size: 11px;
            line-height: 11px;
        }
    }
    &_rules {
        margin-top: 86px;
        padding: 0 103px;
        font-size: 13px;
        width: 100%;
        line-height: 20.8px;
        @media @sm {
            margin-top: 0;
            padding: 0 16px;
            margin-bottom: 46px;
            font-size: 11px;
        }
    }
    @media (max-width: 815px) {
        &_about {
            flex-wrap: wrap;
        }
    }
    @media (max-width: 580px) {
        &_about {
            padding: 18px 16px 30px;
        }
        &_link {
            margin-top: 0;
        }
    }
}
.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100% !important;
}
</style>

<style lang="less">
.swiper-pagination {
    display: flex;
    gap: 10px;
    position: absolute;
    bottom: 5px;
    width: 100%;
    justify-content: center;
    &-bullet {
        border-radius: 0 !important;
        transform: rotate(45deg);
        background-color: @border2 !important;
        opacity: 1 !important;
        width: 5.66px !important;
        height: 5.66px !important;
        &-active {
            background-color: #000000 !important;
        }
    }
}
</style>
